import * as http from "../http";
// @ts-ignore
import { getAuthConfig } from "cwb-react";
import {
  ICountryDto,
  ICountryCitiesDto,
  IIpDetailsDto,
} from "./dtos/IReferencesDto";

const api = `${process.env.REACT_APP_REG_Api}/References`;

export const getCountries = () => {
  return http.get<ICountryDto[]>(`${api}/countries`);
};

export const getCountriesWithCities = () => {
  return http.get<ICountryCitiesDto[]>(`${api}/CitiesWithCountry`);
};

export const getSupportedCitiesCountries = () => {
  return http.get<ICountryCitiesDto[]>(`${api}/supported-cities-countries`);
};

export const getRequesterCountryCode = (forcedFallback?: string | null) => {
  // Only append forcedFallback when it's a real value — a naive
  // `?forcedFallback=${undefined}` sends the literal string "undefined",
  // which the backend treats as a valid fallback country code.
  const url = forcedFallback
    ? `${api}/country/code?forcedFallback=${encodeURIComponent(forcedFallback)}`
    : `${api}/country/code`;
  // Drop only the CWB custom header so this stays a CORS "simple request"
  // (no preflight OPTIONS). Keep credentials: a credentialed request does NOT
  // trigger a preflight, and preserving it keeps cookie behaviour identical to
  // every other call across our different API domains/subdomains.
  return http.get<IIpDetailsDto>(url, {
    method: "GET",
    mode: "cors",
    credentials: "include",
  });
};

export const refresh = () => {
  return http.get(`${api}/refresh`, {
    method: "GET",
    mode: "cors",
    credentials: "include",
    headers: {
      CWB: "1",
      ...getAuthConfig().headers,
    },
  });
};
